export class AccessToken {
  token_type: string
  scope: string
  expires_in: number
  ext_expires_in: number
  access_token: string
  refresh_token: string
  id_token: string
  expire_at: Date
  user_groups: string[]
static isInProgress: boolean=false;
}